import {basicContext} from "../../../../utils/contextUtils";

const {fieldPathJoinGetter} = require( "../../../../utils/kp3Utils")
const _ = require('lodash')


export const entities = [
    {
        name: "FollowUpByMonth",
        type: "mongoInternal",
        fields: [
            {path: "projectQuadruplet"},
            {path: 'month'},
            {path: "budget", type: 'decimal' },
            {path: "validated", type: 'decimal'},
            {path: "estimated", type: 'decimal'},
            {path: "revised", type: 'decimal'},
            {path: "engaged", type: 'decimal'},
            {path: "ongoing", type: 'decimal'},
        ]
    },
    {
        name: "FollowTable",
        type: "mongoInternal",
        //il cree les champs dans le composant père, pour eviter la création des collections pour cette entité
        fields: [
            //en se basant sur les steps
            {path: 'analyticalSubAxis', type: 'AnalyticalSubAxis'},
            {path: 'analyticalMesh', type: 'AnalyticalMesh'},
            {path: 'entity', type: 'OrganizationalMesh'},
            {path: 'imputationType', type: 'ImputationType'},
            {
                path: "projectQuadruplet",
            },
            //identifier: `${code} - ${budget.analyticalMesh.code} - ${budget.mesh.code} - ${typeObject.code}`,
            {path: "followUpByMonth", type: "FollowUpByMonth", link: {type: "OTM"}},
            {path: "budget", type: "decimal"},
            {path: "validated", type: "decimal"},
            {path: "estimated", type: "decimal"},
            {path: "revised", type: "decimal"},
            {path: "engaged", type: "decimal"},
            {path: "ongoing", type: "decimal"},
        ]
    },
    {
        name: "FollowUpByMonth2",
        type: "mongoInternal",
        fields: [
            {path: "imputationTriplet"},
            {path: 'month'},
            {path: "estimated", type: 'decimal'},
            {path: "validated", type: 'decimal'},
            {path: "revised", type: 'decimal'},
        ]
    },
    {
        name: "FollowTable2",
        type: "mongoInternal",
        //il cree les champs dans le composant père, pour eviter la création des collections pour cette entité
        fields: [
            {path: 'correspondentImputation', type: 'Imputation'}, // display
            {path: "followUpByMonth", type: "FollowUpByMonth2", link: {type: "OTM"}},
        ]
    },
    {
        name: 'ArbitrateTextList',
        type: 'mongoInternal',
        fields: [
            {
                path: 'user',
                type:'User'
            },
            'step',
            'order',
            "ArbitrationType",
            {path: 'motif'},
            {
                path: "date",
                type: 'date',
                dateFormat: 'YYYY-MM-DD HH:mm'
            },
        ]
    },
    {
        name: 'AnalyticalSubAxis',
        facets: [
            {name: 'codeName', nameOptional: false, uniqueName: false, uniqueCode: true}
        ],
        fields: [
            {path: 'analyticalAxis', type:'AnalyticalAxis', link:'MTO'},
            /*fieldPathJoinGetter({
                path: 'nameWithAnalyticalAxis',
                fieldPath: ['analyticalAxis.name', 'name'],
                joinString: ' : '
            }),*/
            {
                path: 'nameWithAnalyticalAxis',
                fieldPath: ['analyticalAxis.name', 'name'],
                $f: function (object, context, callback) {
                    if(!context.translateName) return callback(null, `${object.analyticalAxis.name} : ${object.name}`)
                    callback(null, `${context.translateName(object.analyticalAxis.name)} : ${context.translateName(object.name)}`)
                }
            },
        ],
        filters: [
            {
                name: "analyticalAxisIsProjectAxis",
                isDefault: false,
                async: true,
                query: function(context, callback) {
                    global.app.SE.AnalyticalAxis.find(
                        {
                            ...basicContext(context),
                            fieldPath: [],
                            query: {
                                isProjectAxis: true
                            }
                        },(e, axes) => {
                            if (e) return callback(e)
                            if (!!axes.length ){
                                const axesInBudgetAxes = axes.map( axes => new global.ObjectID(axes.id))
                                callback(e, {"analyticalAxis": {$in: axesInBudgetAxes}})
                            }
                            else{
                                callback(e, {_id: null})
                            }
                        }
                    )
                }
            },
            {
                name: 'byAnalyticalAxis',
                tKey: 'analyticalAxis',
                isDefault: false,
                client: true,
                path: 'analyticalAxis',
                object: 'AnalyticalAxis',
                display: 'name',
                clearable: true,
                translateName: true,
                query: function(context) {
                    const analyticalAxisID = _.get(context, 'data.analyticalAxis.id')
                    return analyticalAxisID ? {"analyticalAxis": new global.ObjectID(analyticalAxisID)} : {}
                }
            },
            /*
            {
                name: 'followUpProjects',
                isDefault: false,
                objectFieldPath: ['attachedDemand.status'],
                match: object => {
                    const statusId = _.get(object, 'attachedDemand.status.id')
                    return !object.attachedDemand || ["6", "7", "8"].includes(statusId)
                }
            },
             */
        ]
    }
]
export const module_ = {
    object: 'AnalyticalSubAxis',
    category: {
        path: 'referencial',
        icon: 'briefcase'
    },
    tKey: 'analyticalSubAxis',
    defaultSortBy: 'name',
    defaultSortDirection: 'ASC',
    viewMap: {
        dt: [
            'code',
            {path: 'name', type: 'translatedText'}
        ],
        form: [
            {path: 'analyticalAxis', display: 'name', editable: false, translateName: true},
            {path: 'code', editable: false},
            {path: 'name', type: 'textarea', placeholder: 'fr:: nom en français\nen:: name in english\n...'}
        ],
    },
    filters: ['byAnalyticalAxis']
}
